import { LoadingButton } from '@mui/lab';
import { Grid, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TranslateText } from '../../../application/language/TranslateText';
import { useI18n } from '../../../application/language/useI18n';
import { ICommonProperties } from '../../../common/properties/ICommonProperties';
import { observer } from 'mobx-react';
import React from 'react';

import { Colors } from '../color/Colors';

export interface IFormActionsProperties extends ICommonProperties {
  onSave: any;
  onCancel: any;
  onDelete?: any;
  disabled?: boolean;
  isLoading?: boolean;
  isEdit?: boolean;
}

export const FormActions = observer(
  ({ onCancel, onSave, disabled = false, onDelete = null, isLoading = false, isEdit = true }: IFormActionsProperties) => {
    const classes = useStyles();
    return (
      <Grid container className={classes.container}>
        <Grid item>
          <LoadingButton
            variant="outlined"
            size="large"
            className={classes.actionButton}
            onClick={onCancel}
            loading={isLoading}
            disabled={disabled}
          >
            <TranslateText i18nKey="phrases.cancel" />
          </LoadingButton>
          {onDelete && (
            <LoadingButton
              variant="outlined"
              className={classes.actionButton}
              onClick={onDelete}
              disabled={disabled}
              loading={isLoading}
              style={{ color: Colors.errorLight, borderColor: Colors.errorLight }}
            >
              <TranslateText i18nKey="phrases.delete" />
            </LoadingButton>
          )}
          <LoadingButton
            variant="contained"
            color="primary"
            size="large"
            className={classes.actionButton}
            onClick={onSave}
            disabled={disabled}
            loading={isLoading}
          >
            <TranslateText i18nKey={isEdit ? "phrases.save" : "buttonsText.addButton"} />
          </LoadingButton>
        </Grid>
      </Grid>
    );
  },
);

export const FormAddButton = observer(({ onSave, disabled = false, isLoading = false, buttonText }) => {
  const { translate } = useI18n();

  const saveButtonText = buttonText || translate('phrases.save');
  return (
    <Grid style={{ marginLeft: '10px' }}>
      <LoadingButton
        variant="contained"
        color="primary"
        onClick={() => {
          onSave();
        }}
        disabled={disabled}
        loading={isLoading}
      >
        {saveButtonText}
      </LoadingButton>
    </Grid>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'flex-end',
  },
  actionButton: {
    margin: theme.spacing(2),
  },
}));
